import { ValidationStrategyFactory } from "./validation-strategy.factory";
import { ValidationStrategy } from "./validation.strategy";

export class CheckboxValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        if (!this.isRequired || this.isDisabled || this.isHidden) {
            return true;
        }

        if(this.attribute.attributes.length > 0) {
            return this.attribute.attributes.some(attr => 
                attr.options.some(opt => opt.key.toLowerCase() == "checked" && opt.value.toLowerCase() == "true"));
        } else {
            return this.attribute.value && this.attribute.value.toLowerCase() == "true";
        }
    }
}